/**
 * Agreement Gate Store — holds the list of user agreements the current user
 * must still accept before they can use the app. Populated from the login
 * response and from any 423 Locked API response.
 *
 * Pattern mirrors authStore.js: module-level state + pub/sub listeners +
 * a React hook for subscribing components.
 */

import { useEffect, useState } from 'react';

let pending = [];
const listeners = new Set();

function notify() {
  listeners.forEach((l) => {
    try { l(pending); } catch (e) { console.error('agreementGateStore listener error:', e); }
  });
}

export function getPending() {
  return pending;
}

export function setPending(next) {
  pending = Array.isArray(next) ? next : [];
  notify();
}

export function clearPending() {
  pending = [];
  notify();
}

export function usePendingAgreements() {
  const [value, setValue] = useState(pending);
  useEffect(() => {
    listeners.add(setValue);
    return () => listeners.delete(setValue);
  }, []);
  return value;
}
